var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39:393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8507 3.32391V2.74039C24.8507 1.22938 23.6213 0 22.1103 0C20.5993 0 19.3699 1.22938 19.3699 2.74039V3.32391H17.2404V2.74039C17.2404 1.22938 16.011 0 14.5 0C12.989 0 11.7596 1.22938 11.7596 2.74039V3.32391H9.63008V2.74039C9.63008 1.22938 8.4007 0 6.88969 0C5.37867 0 4.1493 1.22938 4.1493 2.74039V3.32391H0.5V28H28.5V3.32391H24.8507ZM21.0105 2.74039C21.0105 2.13391 21.5038 1.64062 22.1103 1.64062C22.7168 1.64062 23.2101 2.13391 23.2101 2.74039V3.32391H21.0105V2.74039ZM13.4002 2.74039C13.4002 2.13391 13.8935 1.64062 14.5 1.64062C15.1065 1.64062 15.5998 2.13391 15.5998 2.74039V3.32391H13.4002V2.74039ZM5.78992 2.74039C5.78992 2.13391 6.2832 1.64062 6.88969 1.64062C7.49617 1.64062 7.98945 2.13391 7.98945 2.74039V3.32391H5.78992V2.74039ZM7.98945 4.96453V5.50539C7.98945 6.11188 7.49617 6.60516 6.88969 6.60516V8.24578C8.4007 8.24578 9.63008 7.01641 9.63008 5.50539V4.96453H15.5998V5.50539C15.5998 6.11188 15.1065 6.60516 14.5 6.60516V8.24578C16.011 8.24578 17.2404 7.01641 17.2404 5.50539V4.96453H23.2101V5.50539C23.2101 6.11188 22.7168 6.60516 22.1103 6.60516V8.24578C23.6213 8.24578 24.8507 7.01641 24.8507 5.50539V4.96453H26.8594V9.88641H2.14062V4.96453H7.98945ZM2.14062 26.3594V11.527H26.8594V26.3594H2.14062Z",
    fill: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39:393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientHistory);
export default __webpack_public_path__ + "static/media/PatientHistory.6fee9aa525be018e9fe2e8616fb09bd7.svg";
export { ForwardRef as ReactComponent };